import "./SolomonBrown.module.css";
import Header from "@/reusable_sections/Header";
import FromVoiceToVelocity from "./sections/FromVoiceToVelocity";
import TheHumanBehindTheWork from "./sections/TheHumanBehindTheWork";
import PulseOfTheStudio from "./sections/PulseOfTheStudio";
import PitStopHighlights from "./sections/PitStopHighlights";
import Footer from "@/reusable_sections/Footer";
export default function SolomonBrownPage() {
  return <div>
      <Header />
      <FromVoiceToVelocity />
      <TheHumanBehindTheWork />
      <PulseOfTheStudio />
      <PitStopHighlights />
      <Footer />
    </div>;
}